import { Link } from "react-router-dom";
import { categoryNameMap, formatViews, type Video } from "@/mocks/videos";
import FavoriteButton from "@/components/base/FavoriteButton";

interface VideoListItemProps {
  video: Video;
  index?: number;
}

export default function VideoListItem({ video, index = 0 }: VideoListItemProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      data-product-shop="video"
      style={{ animationDelay: `${Math.min(index, 10) * 35}ms` }}
      className="group flex flex-col sm:flex-row gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors animate-fade-up cursor-pointer"
    >
      <div className="relative w-full sm:w-56 md:w-64 shrink-0 aspect-video rounded-md overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} - 亲吻视频封面`}
          title={`${video.title} - 亲嘴视频`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/75 text-background-50 text-xs font-label">
          {video.duration}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl" />
          </div>
        </div>
      </div>

      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-start justify-between gap-3">
          <h3 className="text-base md:text-lg font-medium text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
            {video.title}
          </h3>
          <FavoriteButton videoId={video.id} size="sm" />
        </div>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {video.description}
        </p>
        <div className="mt-auto pt-3 flex items-center gap-x-4 gap-y-1 flex-wrap text-xs text-foreground-500 font-label">
          <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900">
            {categoryNameMap[video.categoryKey]}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-global-line" />
            {video.region}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {video.year}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-play-circle-line" />
            {formatViews(video.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {video.uploadedAt}
          </span>
        </div>
      </div>
    </Link>
  );
}